import Text from 'antd/lib/typography/Text';
import React, { useEffect } from 'react';

import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
} from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormInput from 'components/FormInput';

import ParListSelect from 'components/ParListSelect';
import { shouldUpdateCompare } from 'utils/utils2';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import { PricingResponse } from 'services/pricing';
import * as finEngine from 'services/finEngine';
import { toCurrency } from 'utils/utils';
import { useForm } from 'antd/lib/form/Form';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import ParListSelectWithLabelInValue from 'components/ParListSelectWithLabelInValue/ParListSelectWithLabelInValue';
import InputCurrency from 'components/InputCurrency/InputCurrency';

export type AssetTargetPhaseModalProps = {
  form?: FormInstance;
  visible?: boolean;
  onCancel: () => void;
  onSave: (target: any) => void;
  tpidclient?: number;
  currcode?: string;
  prcode?: string;
  offerid?: number;
  asset?: any;
  effectDate?: string;
  disabled?: boolean;
  vatrefundduration: number;
};

const initialValues = {
  degfeesamount: 0,
  spamount: 0,
  tpofamount: 0,
  totalinvoiceamount: 0,
  saleamount: 0,
  feesamount: 0,
  vatrefund: 0,
};

const AssetTargetPhaseModal = (props: AssetTargetPhaseModalProps) => {
  const {
    visible,
    onCancel,
    onSave,
    form,
    tpidclient,
    currcode,
    prcode,
    offerid,
    asset,
    effectDate,
    disabled,
  } = props;

  // const totalRV = sumBy(asset, 'assetrvamount');
  // const taxRV = (totalRV * 20) / 100;
  const [formM] = useForm();

  const calculateFees = (
    asset: any,
    pricing?: PricingResponse,
    ctetype?: string
  ) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: [],
          inDownPayment: 0,
          inFinAmount: asset?.assetnetamount ?? 0,
          inFollowGP: true,
          inGPDuration: 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: pricing?.taxrate ?? 0,
          inDuration: 0,
          inInvestAmount: asset?.assetnetamount,
          inAssetAmount: asset?.assetnetamount,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: effectDate!,
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);
          if (ctetype === 'PPOF') {
            formM?.setFieldsValue({ tpofamount: res.installmentamount });
          } else {
            if (ctetype === 'DEGFEES') {
              formM?.setFieldsValue({ degfeesamount: res.installmentamount });
            } else {
              // SPFEES :
              formM?.setFieldsValue({
                spamount:
                  res.installmentamount * formM?.getFieldValue('spvalue'),
              });
            }
          }

          const newtotal =
            formM?.getFieldValue('targetphase') === 'ASSETOUT'
              ? Number(formM?.getFieldValue('saleamount')) +
                Number(formM?.getFieldValue('tpofamount'))
              : Number(formM?.getFieldValue('degfeesamount')) +
                Number(formM?.getFieldValue('spamount')) +
                Number(formM?.getFieldValue('tpofamount'));
          formM?.setFieldsValue({
            totalinvoiceamount: newtotal,
          });

          //calculateTotal();
        }
      });
  };

  const calculateTotal = (phase: any) => {
    const saleamount =
      phase === 'ASSETOUT'
        ? asset.irvamount > asset.finrvamount
          ? asset.irvamount
          : asset.finrvamount
        : 0;

    formM?.setFieldsValue({
      saleamount: saleamount,
      totalinvoiceamount: saleamount,
      tpofamount: 0,
      spamount: 0,
      degfeesamount: 0,
      targetstatus: '',
    });

    // if (formM?.getFieldValue('targetphase') === 'STOCKIN') {
    //   form?.setFieldsValue({
    //     invoicenetamount: form.getFieldValue('degfeesamount'),
    //     invoicetaxamount: form.getFieldValue('feestax'),
    //     invoicegrossamount:
    //       form.getFieldValue('degfeesamount') + form.getFieldValue('feestax'),
    //   });
    // } else {
    //   form?.setFieldsValue({
    //     invoicenetamount: totalRV,
    //     invoicetaxamount: taxRV,
    //     invoicegrossamount: totalRV + taxRV,
    //   });
    // }
  };

  const onfinish = (values: any) => {
    const target = {
      ...values,
      assetid: asset.assetid,
      degfeesformula: values.degfeesformula?.priid,
      degfeesformulalabel: values.degfeesformula?.prilabel,
      tpofformula: values.tpofformula?.priid,
      tpofformulalabel: values.tpofformula?.prilabel,
      spformula: values.spformula?.priid,
      spformulalabel: values.spformula?.prilabel,
      fees: values.fees?.value,
      feesamount: values?.feesamount,
      feeslabel: values?.feeslabel,
      vatrefund: values?.vatrefund ?? 0,
    };

    onSave(target);
    formM.resetFields();
    onCancel();
  };

  useEffect(() => {
    if (asset) {
      formM.setFieldsValue({
        ...asset,
        targetphase: asset.targetphase,
        targetstatus: asset.targetstatus,
        finrvamount: asset.finrvamount ?? 0,
        marketvalue: asset.irvamount ?? 0,
        degfeesamount: asset.degfeesamount ?? 0,
        tpofamount: asset.tpofamount ?? 0,
        spamount: asset.spamount ?? 0,
        saleamount: asset.saleamount ?? 0,
        vatrefund: asset.vatrefund ?? 0,
        feesamount: asset.feesamount ?? 0,
        totalinvoiceamount: asset.totalinvoiceamount ?? 0,
        contractualmillage: asset.maxMileageToUse,
      });
    } else formM.setFieldsValue({});
  }, [asset, form, formM, visible]);

  return (
    (<Form
      form={formM}
      initialValues={initialValues}
      onFinish={onfinish}
      layout="vertical"
      onFinishFailed={onFinishFailed}
    >
      <Modal
        open={visible}
        title={
          'Asset to Terminate : ' +
          asset?.assetreference +
          ' - ' +
          asset?.assetlabel
        }
        footer={[
          <Button
            key="Cancel"
            onClick={() => {
              formM.resetFields();
              onCancel();
            }}
          >
            Cancel
          </Button>,
          <Button key="Validate" type="primary" onClick={formM.submit}>
            Validate
          </Button>,
        ]}
        onCancel={() => {
          formM.resetFields();
          onCancel();
        }}
        width="1200px"
        destroyOnClose
      >
        <Card>
          <Row gutter={30}>
            <FormInput
              col
              xs={8}
              name="targetphase"
              rules={[{ required: true }]}
            >
              <ParListSelect
                disabled={disabled}
                parcode="ASSETEND"
                onChange={calculateTotal}
              />
            </FormInput>
            <Form.Item
              shouldUpdate={shouldUpdateCompare('targetphase')}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput
                  col
                  xs={10}
                  name="targetstatus"
                  rules={[{ required: true }]}
                >
                  <ParListSelect
                    parcode="ASSETSTAT"
                    parvalueparent={getFieldValue('targetphase')}
                    disabled={disabled}
                  ></ParListSelect>
                </FormInput>
              )}
            </Form.Item>
            <Form.Item
              shouldUpdate={shouldUpdateCompare('totalinvoiceamount')}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput col xs={6} name="totalinvoiceamount">
                  <Text type="danger" strong>
                    {toCurrency(getFieldValue('totalinvoiceamount'), currcode)}
                  </Text>
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row gutter={30}>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const display = getFieldValue('targetphase') === 'STOCKIN';
                if (display) {
                  return (
                    <>
                      <Divider orientation="left">Damage</Divider>
                      <FormInput
                        col
                        xs={6}
                        name="damage"
                        //rules={[{ required: true }]}
                      >
                        <ParListSelect
                          parcode="DAMLEVEL"
                          onChange={() => {
                            props.form?.setFieldsValue({
                              degfeesamount: 0,
                              feestax: 0,
                              feesformula: '',
                            });
                          }}
                          disabled={disabled}
                        />
                      </FormInput>

                      <FormInput
                        col
                        xs={12}
                        name="degfeesformula"
                        //rules={[{ required: true }]}
                      >
                        <PricingListFilteredSelect
                          //disabled={!getFieldValue('offerid')}
                          allowClear
                          params={{
                            offerid: offerid ?? 0,
                            ctetype: 'DEGFEES', // Modifictaion fees
                            prcode: prcode! ?? '',
                            entity: '',
                            entityid: 0,
                            tpid: tpidclient ?? 0,
                            filtersPricing:
                              'DAMLEVEL=' + getFieldValue('damage') + ',',
                          }}
                          onChange={(e) => calculateFees(asset, e, 'DEGFEES')}
                          disabled={disabled}
                        />
                      </FormInput>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('degfeesamount')}
                        noStyle
                      >
                        {({ getFieldValue }) => (
                          <FormInput col xs={6} name="degfeesamount">
                            <Text type="danger" strong>
                              {toCurrency(
                                getFieldValue('degfeesamount'),
                                currcode
                              )}
                            </Text>
                          </FormInput>
                        )}
                      </Form.Item>
                      <Divider orientation="left">Specific Conditions</Divider>

                      <FormInput
                        col
                        xs={6}
                        name="contractualmillage"
                        labelAlign="left"
                        //rules={[{ required: true }]}
                      >
                        <InputNumber
                          onChange={(e) => {
                            console.log('eee', e);
                          }}
                        />
                      </FormInput>

                      <FormInput
                        col
                        xs={6}
                        name="currentMileage"
                        labelAlign="left"
                        //rules={[{ required: true }]}
                      >
                        <InputNumber
                          onChange={(e) => {
                            let diff =
                              Number(e) -
                              formM?.getFieldValue('contractualmillage');
                            formM?.setFieldValue(
                              'spvalue',
                              diff > 0 ? diff?.toFixed(2) : 0
                            );
                          }}
                        />
                      </FormInput>

                      <FormInput
                        col
                        xs={6}
                        name="spvalue"
                        //rules={[{ required: true }]}
                      >
                        <InputNumber disabled={disabled} />
                      </FormInput>

                      <FormInput
                        col
                        xs={12}
                        name="spformula"
                        // rules={[{ required: true }]}
                      >
                        <PricingListFilteredSelect
                          //disabled={!getFieldValue('offerid')}
                          allowClear
                          params={{
                            offerid: offerid ?? 0,
                            ctetype: 'SPFEES', // Modifictaion fees
                            prcode: prcode! ?? '',
                            entity: '',
                            entityid: 0,
                            tpid: tpidclient ?? 0,
                            filtersValue:
                              'NBKMS=' + getFieldValue('spvalue') + ',',
                          }}
                          onChange={(e) => calculateFees(asset, e, 'SPFEES')}
                          disabled={disabled}
                        />
                      </FormInput>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('spamount')}
                        noStyle
                      >
                        {({ getFieldValue }) => (
                          <FormInput col xs={6} name="spamount">
                            <Text type="danger" strong>
                              {toCurrency(getFieldValue('spamount'), currcode)}
                            </Text>
                          </FormInput>
                        )}
                      </Form.Item>
                    </>
                  );
                } else {
                  return (
                    <>
                      <FormInput col xs={9} name="finrvamount">
                        <Text>
                          {toCurrency(getFieldValue('finrvamount'), currcode)}
                        </Text>
                      </FormInput>

                      <FormInput col xs={9} name="marketvalue">
                        <Text>
                          {toCurrency(getFieldValue('marketvalue'), currcode)}
                        </Text>
                      </FormInput>

                      <Form.Item
                        shouldUpdate={shouldUpdateCompare('saleamount')}
                        noStyle
                      >
                        {({ getFieldValue }) => (
                          <FormInput col xs={4} name="saleamount">
                            <Text type="danger" strong>
                              {toCurrency(
                                getFieldValue('saleamount'),
                                currcode
                              )}
                            </Text>
                          </FormInput>
                        )}
                      </Form.Item>
                    </>
                  );
                }
              }}
            </Form.Item>
            <Divider orientation="left">Early Temination fees</Divider>

            <FormInput
              col
              xs={12}
              name="tpofformula"
              //rules={[{ required: true }]}
            >
              <PricingListFilteredSelect
                //disabled={!getFieldValue('offerid')}
                allowClear
                params={{
                  offerid: offerid ?? 0,
                  ctetype: 'PPOF', // Partial Pay off fees
                  prcode: prcode! ?? '',
                  entity: '',
                  entityid: 0,
                  tpid: tpidclient ?? 0,
                  //filters: 'effectDate=' + effectDate + ',',
                }}
                onChange={(e) => calculateFees(asset, e, 'PPOF')}
                disabled={disabled}
              />
            </FormInput>
            <Col span={6} />
            <Form.Item shouldUpdate={shouldUpdateCompare('tpofamount')} noStyle>
              {({ getFieldValue }) => (
                <FormInput col xs={6} name="tpofamount">
                  <Text type="danger" strong>
                    {toCurrency(getFieldValue('tpofamount'), currcode)}
                  </Text>
                </FormInput>
              )}
            </Form.Item>
            <FormInput col xs={6} name="fees">
              <ParListSelectWithLabelInValue
                parcode="CILTYPE"
                parvalueparent="MISCFEES"
                onSelect={(e) => formM.setFieldsValue({ feeslabel: e.label })}
                disabled={disabled}
              />
            </FormInput>
            <FormInput col xs={11} name="feeslabel">
              <Input disabled={disabled} />
            </FormInput>

            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={7} name="feesamount" shouldUpdate>
                    <InputCurrency
                      currcode={
                        currcode ?? localStorage.getItem('currcode') ?? ''
                      }
                      disabled={
                        disabled ||
                        getFieldValue('fees')?.value === undefined ||
                        getFieldValue('fees') === undefined
                      }
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Row>
        </Card>
      </Modal>
    </Form>)
  );
};

export default AssetTargetPhaseModal;
